<template>
    <div class="card p-4 pb-0">
        <AlternativeTripLegInfo v-for="(leg, index) in trip?.outputTripLegs" :leg="(leg)" :key="index">
        </AlternativeTripLegInfo>
    </div>
</template>

<script setup lang="ts">
import AlternativeTripLegInfo from './AlternativeTripLegInfo.vue';
import { AlternativeTrip } from '@/models/AlternativeTrip.model';

defineProps({
    trip: {
        type: Object as () => AlternativeTrip,
        required: true
    }
})

</script>

<style scoped lang="scss">
@import '@/styles/components/instantApproval/result/rejected/_alternativeTripCard';
</style>